var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveAssociateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 72,
    viewBox: "0 0 83 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 47.7C83 50.4 78.85 52.2 74.0083 53.1C70.8958 45.45 64.6708 39.6 57.4083 35.55C58.1 34.2 58.7917 33.3 59.4833 31.95H62.25C72.9708 31.5 83 40.05 83 47.7ZM23.5167 31.5H20.75C10.0292 31.5 0 40.05 0 47.7C0 50.4 4.15 52.2 8.99167 53.1C12.1042 45.45 18.3292 39.6 25.5917 35.55L23.5167 31.5ZM41.5 36C49.1083 36 55.3333 27.9 55.3333 18C55.3333 8.1 49.1083 0 41.5 0C33.8917 0 27.6667 8.1 27.6667 18C27.6667 27.9 33.8917 36 41.5 36ZM41.5 40.5C27.3208 40.5 13.8333 52.2 13.8333 63C13.8333 72 41.5 72 41.5 72C41.5 72 69.1667 72 69.1667 63C69.1667 52.2 55.6792 40.5 41.5 40.5ZM61.2125 27H62.25C68.1292 27 72.625 21.15 72.625 13.5C72.625 5.85 68.1292 0 62.25 0C60.5208 0 59.1375 0.450001 57.7542 1.35C60.5208 5.85 62.25 11.7 62.25 18C62.25 21.15 61.9042 24.3 61.2125 27ZM20.75 27H21.7875C21.0958 24.3 20.75 21.15 20.75 18C20.75 11.7 22.4792 5.85 25.2458 1.35C23.8625 0.450001 22.4792 0 20.75 0C14.8708 0 10.375 5.85 10.375 13.5C10.375 21.15 14.8708 27 20.75 27Z",
    fill: "#95999E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveAssociateIcon);
export default __webpack_public_path__ + "static/media/inActiveAssociateIcon.a67e26f2e00d5f2774d50fa31fba26ae.svg";
export { ForwardRef as ReactComponent };